import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "../../../assets/css/gcstaff/staffsidebar/TeacherSidebar.css";

/* ── Icons ── */
const Icons = {
  Dashboard: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
      <polyline points="9 22 9 12 15 12 15 22"/>
    </svg>
  ),
  MyBooks: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/>
      <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
    </svg>
  ),
  SavedPDFs: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
    </svg>
  ),
  MyNotes: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14 2 14 8 20 8"/>
      <line x1="9" y1="13" x2="15" y2="13"/>
      <line x1="9" y1="17" x2="12" y2="17"/>
    </svg>
  ),
  FlashCards: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
  ),
  Disputes: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
  ),
  WriteReview: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5"/>
      <path d="M17.586 3.414a2 2 0 112.828 2.828L12 14.828 8 16l1.172-4 8.414-8.586z"/>
    </svg>
  ),
   Notifications: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5"/>
      <path d="M17.586 3.414a2 2 0 112.828 2.828L12 14.828 8 16l1.172-4 8.414-8.586z"/>
    </svg>
  ),
  Profile: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  Libraro: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  ),
  Logout: () => (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
      <polyline points="16 17 21 12 16 7"/>
      <line x1="21" y1="12" x2="9" y2="12"/>
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6"/>
    </svg>
  ),
  ChevronRight: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6"/>
    </svg>
  ),
  Menu: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="3" y1="6"  x2="21" y2="6"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
      <line x1="3" y1="18" x2="21" y2="18"/>
    </svg>
  ),
  X: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M18 6L6 18M6 6l12 12"/>
    </svg>
  ),
};

const NAV_ITEMS = [
 
  { label: "Dashboard",   icon: <Icons.Dashboard />,  path: "/teacher/dashboard"  },
  { label: "My Books",    icon: <Icons.MyBooks />,    path: "/teacher/my-books"   },
  { label: "Saved PDFs",  icon: <Icons.SavedPDFs />,  path: "/teacher/saved-pdfs" },
  { label: "My Notes",    icon: <Icons.MyNotes />,    path: "/teacher/my-notes"   },
  { label: "Flash Cards", icon: <Icons.FlashCards />, path: "/teacher/flash-cards"},
  { label: "Disputes",    icon: <Icons.Disputes />,   path: "/teacher/disputes"   },
  { label: "Reviews",    icon: <Icons.Disputes />,   path: "/teacher/reviews"   },
  { label: "Notifications",    icon: <Icons.Notifications />,   path: "/teacher/notifications"   },
 
  { label: "Profile",     icon: <Icons.Profile />,    path: "/teacher/profile"    },
  { label: "SmartLib AI", icon: <Icons.Libraro />,    path: "/teacher/libraro"    },
];

const MOBILE_BP = 992; // breakpoint

const TeacherSidebar = ({ onCollapsedChange, onLogout }) => {
  const location  = useLocation();

  /* ── Desktop: collapsed/expanded ── */
  const [collapsed,  setCollapsed]  = useState(false);

  /* ── Mobile: drawer open/closed ── */
  const [mobileOpen, setMobileOpen] = useState(false);

  /* ── Track viewport ── */
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BP);

  useEffect(() => {
    const fn = () => {
      const mobile = window.innerWidth < MOBILE_BP;
      setIsMobile(mobile);
      if (!mobile) setMobileOpen(false); // close drawer when resizing to desktop
    };
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  /* ── Close drawer on route change (mobile) ── */
  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [location.pathname]);

  /* ── Desktop toggle ── */
  const handleDesktopToggle = () => {
    const next = !collapsed;
    setCollapsed(next);
    if (onCollapsedChange) onCollapsedChange(next);
  };

  /* ── Sidebar class names ── */
  const sidebarClass = [
    "gcTeacher-sb",
    isMobile ? "gcTeacher-sb--mobile"  : "",
    isMobile && mobileOpen ? "gcTeacher-sb--mobile-open" : "",
    !isMobile && collapsed  ? "gcTeacher-sb--collapsed"  : "",
  ].filter(Boolean).join(" ");

  /* show the little active-dot only when there's room for it
     (hidden in desktop collapsed/icon-only mode) */
  const showDot = !collapsed || isMobile;

  return (
    <>
      {/* ══════════════════════════════════════════
          Mobile Top Bar (hamburger)
      ══════════════════════════════════════════ */}
      {isMobile && (
        <div className="gcTeacher-topbar">
          <button
            className="gcTeacher-topbar__hamburger"
            onClick={() => setMobileOpen(o => !o)}
            aria-label="Open menu"
          >
            {mobileOpen ? <Icons.X /> : <Icons.Menu />}
          </button>
          <span className="gcTeacher-topbar__brand">Teacher Panel</span>
        </div>
      )}

      {/* ══════════════════════════════════════════
          Mobile Backdrop
      ══════════════════════════════════════════ */}
      {isMobile && mobileOpen && (
        <div
          className="gcTeacher-backdrop"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* ══════════════════════════════════════════
          Sidebar Panel
      ══════════════════════════════════════════ */}
      <aside className={sidebarClass}>

        {/* ── Header ── */}
        <div className="gcTeacher-sb__head">
          {isMobile ? (
            /* Mobile header: brand + X close */
            <>
              <span className="gcTeacher-sb__brand">Teacher Panel</span>
              <button
                className="gcTeacher-sb__toggle"
                onClick={() => setMobileOpen(false)}
                aria-label="Close menu"
              >
                <Icons.X />
              </button>
            </>
          ) : (
            /* Desktop header: brand + collapse toggle */
            <>
              <span className="gcTeacher-sb__brand">Teacher Panel</span>
              <button
                className="gcTeacher-sb__toggle"
                onClick={handleDesktopToggle}
                aria-label={collapsed ? "Expand" : "Collapse"}
              >
                {collapsed ? <Icons.ChevronRight /> : <Icons.ChevronLeft />}
              </button>
            </>
          )}
        </div>

        {/* ── Nav ── */}
        <nav className="gcTeacher-sb__nav">
          <ul className="gcTeacher-sb__list">
            {NAV_ITEMS.map((item, i) => {
              const active =
                location.pathname === item.path ||
                location.pathname.startsWith(item.path + "/");
              return (
                <li
                  key={item.path}
                  className="gcTeacher-sb__item"
                  style={{ animationDelay: `${i * 0.04}s` }}
                >
                  <NavLink
                    to={item.path}
                    className={`gcTeacher-sb__link ${active ? "gcTeacher-sb__link--active" : ""}`}
                    title={collapsed && !isMobile ? item.label : ""}
                  >
                    <span className="gcTeacher-sb__icon">{item.icon}</span>
                    <span className="gcTeacher-sb__label">{item.label}</span>
                    {active && showDot && <span className="gcTeacher-sb__dot" />}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* ── Footer: Log Out ── */}
        <div className="gcTeacher-sb__footer">
          <div className="gcTeacher-sb__divider" />
          <button
            className="gcTeacher-sb__logout"
            onClick={onLogout}
            title={collapsed && !isMobile ? "Log Out" : ""}
          >
            <span className="gcTeacher-sb__icon gcTeacher-sb__icon--logout">
              <Icons.Logout />
            </span>
            <span className="gcTeacher-sb__label">Log Out</span>
          </button>
        </div>

      </aside>
    </>
  );
};

export default TeacherSidebar;